export default __webpack_public_path__ + "static/media/19.d1d5c07a.png";